module.exports = __webpack_public_path__ + "images/help_v2/avatars/xiawei-7b4205eb545ba1a4522009e7a786c7e7.png";